
/**
 * Joins a string array(`inputArr`) with the separator for
 * all elements expect the last two elements which are joined
 * by `lastSeparator`
 *
 * @export
 * @param {[String]} inputArr
 * @param {String} separator
 * @param {String} lastSeparator
 * @returns {String}
 */
export default function joinLastSeparator(inputArr, separator, lastSeparator) {
    // Throw error if inputArr not an array
    if(!Array.isArray(inputArr))
        throw new TypeError('Expected an Array as input')

    // Return empty string for empty array
    if(inputArr.length === 0)
        return ''

    // Return the array element if there is just one element
    if(inputArr.length === 1)
        return inputArr[0]

    return inputArr.slice(0, -1).join(separator) + lastSeparator + inputArr[inputArr.length - 1]
}
